import { AttachmentBlockSchema } from '@blocksuite/hive-model';
import { SlashMenuConfigExtension } from '@blocksuite/hive-widget-slash-menu';
import { BlockViewExtension, FlavourExtension } from '@blocksuite/std';
import type { ExtensionType } from '@blocksuite/store';
import { literal } from 'lit/static-html.js';

import { AttachmentBlockNotionHtmlAdapterExtension } from './adapters/notion-html.js';
import { AttachmentDropOption } from './attachment-service.js';
import { attachmentSlashMenuConfig } from './configs/slash-menu.js';
import { createBuiltinToolbarConfigExtension } from './configs/toolbar';
import {
  AttachmentEmbedConfigExtension,
  AttachmentEmbedService,
} from './embed';

const flavour = AttachmentBlockSchema.model.flavour;

export const AttachmentBlockSpec: ExtensionType[] = [
  FlavourExtension(flavour),
  BlockViewExtension(flavour, model => {
    return model.parent?.flavour === 'hive:surface'
      ? literal`hive-edgeless-attachment`
      : literal`hive-attachment`;
  }),
  AttachmentDropOption,
  AttachmentEmbedConfigExtension(),
  AttachmentEmbedService,
  AttachmentBlockNotionHtmlAdapterExtension,
  createBuiltinToolbarConfigExtension(flavour),
  SlashMenuConfigExtension(flavour, attachmentSlashMenuConfig),
].flat();
